import React, { Component } from 'react';
import Modal from 'react-modal';
import firebase from 'firebase';
import Select from 'react-select';
import Alert from 'react-s-alert';
import {sendLog} from '../../util'

class ModalTarifasAvianca extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tarifa: this.props.tarifa || {},
            updating: this.props.updating || false,
            tiposVehiculo: [],
            valores: this.props.tarifa.valores || {},
            areas: [],
            areaU: {}
        }
    }

    componentDidUpdate = (prevProps) =>{
        let { updating, tarifa } = this.props;
        if(prevProps.updating !== updating){
            this.setState({ updating })
        }
        if(prevProps.tarifa !== tarifa){
            this.setState({ tarifa })
        }
    }

    componentDidMount(){ this.getTiposVehiculo() }

    getTiposVehiculo(){
        firebase.database().ref('Tipos_Vehiculos').once('value').then(snap => {
            let nuevoTipo = [];
            snap.forEach(element => {
                let e = element.val();
                nuevoTipo.push({ ...e, key: element.key });
            });
            let tiposVehiculo = nuevoTipo.filter(nuevoTipo => nuevoTipo.estado=='Activo');
            this.setState({ tiposVehiculo });
        })
    }

    componentDidUpdate(prevProps){
        if(prevProps.tarifa !== this.props.tarifa){
            this.setState({ tarifa: this.props.tarifa, valores: this.props.tarifa.valores, updating: this.props.updating });
        }
    }

    handleChange = (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        const name = e.target.name;
        this.setState({ tarifa: { ...this.state.tarifa, [name]: value }});
    }

    handleChangeChild = (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        const name = e.target.name;
        this.setState({ tarifa: { ...this.state.tarifa, valores: { ...this.state.tarifa.valores, [name]: value } }});
    }

    changeArea = (event) => {
        this.setState({ tarifa: { ...this.state.tarifa, areaU: event.value }});
    }

    handleSubmit(e){
        e.preventDefault();
        this.state.updating ? this.updateTarifa() : this.pushTarifa();
        this.props.toggleModal();
    }

    updateTarifa(){ 
        let { tarifa } = this.state;
        let safeData = tarifa;
        let valueTari = Object.keys(tarifa.valores);
        let valores = {};
        valueTari.forEach(element => {
            if(tarifa.valores[element] !== undefined && tarifa.valores[element] !== null){
                let nameFormat = element.replace(".", "");
                valores[nameFormat] =  tarifa.valores[element];
            }
       });
       safeData.valores = valores;
       firebase.database().ref('TarifasAvianca').child(this.props.tarifa.key).update(safeData)
       sendLog({ tipo: 'tarifa_avianca_editada', informacion_extra: {tarifa_avianca: this.props.tarifa.key} }); 
       Alert.success('Datos Modificados', {
            effect: 'genie',
            position: 'bottom-right',
            timeout: 2000
        });
    }

    pushTarifa(){ 
        let { tarifa } = this.state;
        let safeData = tarifa;
        let valueTari = Object.keys(tarifa.valores);
        let valores = {};
        valueTari.forEach(element => {
            if(tarifa.valores[element] !== undefined && tarifa.valores[element] !== null){
                let nameFormat = element.replace(".", "");
                valores[nameFormat] =  tarifa.valores[element];
            }
       });
       safeData.valores = valores;
       const idKey = firebase.database().ref('TarifasAvianca').push(safeData).key
       sendLog({ tipo: 'tarifa_avianca_nueva', informacion_extra: {tarifa_avianca: idKey} });
       Alert.success('Datos Guardados', {
        effect: 'genie',
        position: 'bottom-right',
        timeout: 2000
    }); 
    }

    getArea(){
        let { tarifa } = this.state;
        let { areasU } = this.props;
        let z = areasU.find(v => v.value === tarifa.areaU);
        if(z === undefined){
            return null;
        }
        return z;
    }

    render() {
        let { tarifa, tiposVehiculo, valores } = this.state;
        let { toggleModal, isActive, startNew, tarifaV, areasU } = this.props;
        return (
            <div className="modal-tarifas">
                <button className="btn btn-primary" onClick={startNew}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
                <Modal onRequestClose={toggleModal} isOpen={isActive} style={customStyles}>
                    <h3>Agregar una nueva tarifa</h3>
                    <hr />
                    <form onSubmit={this.handleSubmit.bind(this)}>
                        <div className="form-group">
                            <label htmlFor="tipo">Nombre</label>
                            <input type="text" name="tipo" defaultValue={tarifaV.tipo} required id="tipo" placeholder="Nombre" className="form-control" autoComplete="off" onChange={this.handleChange.bind(this)}/>
                        </div>
                        <div className="form-group">
                            <label htmlFor="origen">Origen</label>
                            <input onChange={this.handleChange.bind(this)} defaultValue={tarifaV.origen} type="text" name="origen" placeholder="Origen" className="form-control" autoComplete="off" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="destino">Destino</label>
                            <input onChange={this.handleChange.bind(this)} defaultValue={tarifaV.destino} type="text" name="destino" placeholder="Destino" className="form-control" autoComplete="off" required />
                        </div>
                        <div className="form-group">
                            <label>Area usuario</label>
                            <Select onChange={this.changeArea} value={this.getArea()} placeholder="Seleccione una opcion" options={areasU} />
                        </div> 
                        {
                            tiposVehiculo.map(s => {
                                return(
                                    <div className="form-group">
                                        <label htmlFor={s.tipo}>{s.tipo}</label>
                                        <input type="number" min="0.00" step="0.01" onChange={this.handleChangeChild.bind(this)} defaultValue={tarifaV.valores !== undefined ? tarifaV.valores[s.tipo.replace(".", "")] : ''} name={s.tipo} placeholder={s.tipo} className="form-control" autoComplete="off" required />
                                    </div>
                                );
                            })
                        }
                        <hr />
                        <button type="submit" className="btn btn-primary buttons">Guardar</button>
                    </form>
                    <button type="button" onClick={toggleModal} className="btn btn-default buttons  btnmargin">Cerrar</button>
                </Modal>
            </div>
        )
    }
}

export default ModalTarifasAvianca;

const areas = [
    { label: "Pilotos", value: "1" },
    { label: "Tripulantes de Cabina", value: "2" },
    { label: "Personal Tierra AM", value: "3" },
    { label: "Personal Tierra PM", value: "4" },
]

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        width: '450px',
        height: '500px'
    }
}


// WEBPACK FOOTER //
// ./src/Components/Tarifas/ModalTarifasAvianca.js